var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 171,
    viewBox: "0 0 285 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0390625 24.4317C0.0390625 16.0309 0.0390625 11.8305 1.67396 8.62178C3.11207 5.79935 5.40677 3.50464 8.22921 2.06654C11.4379 0.431641 15.6383 0.431641 24.0391 0.431641H260.193C268.593 0.431641 272.794 0.431641 276.002 2.06654C278.825 3.50464 281.12 5.79935 282.558 8.62178C284.193 11.8305 284.193 16.0309 284.193 24.4316V170.076H0.0390625V24.4317Z",
    fill: "#F5FBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M171.85 55.7979H102.858C98.0711 55.7979 94.2765 59.0748 94.2765 63.1618L94.2334 107.346C94.2334 111.433 98.0711 114.71 102.858 114.71H171.85C176.637 114.71 180.475 111.433 180.475 107.346V63.1618C180.475 59.0748 176.637 55.7979 171.85 55.7979ZM171.85 107.346H102.858V85.2537H171.85V107.346ZM171.85 70.5258H102.858V63.1618H171.85V70.5258Z",
    fill: "#A3D9E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardImage);
export default __webpack_public_path__ + "static/media/CardImage.3af923b8654e08e503721fdb91a6651f.svg";
export { ForwardRef as ReactComponent };